export const  aboutCards = [
    {
      title: "From Passion to Profession",
      description:
        "Our garage was founded with the mission of offering top-notch car modification and repair services. The founder, a true car enthusiast, wanted to create a space where drivers could bring their vehicles to receive the best care possible. With a passion for the industry and a commitment to excellence, our garage has become a trusted name in the community.",
      image: require("../../assets/images/aboutimage1.jpg"),
    },
    {
      title: "Leading the Way",
      description:
        "Today, our garage is widely recognized as one of the best in the area. We have gained popularity due to our attention to detail, use of high-quality parts, and exceptional customer service. We are proud sponsors of local racing events and car shows, further establishing our reputation as a leader in the industry.",
      image: require("../../assets/images/aboutimage2.jpg"),
    },
    {
      title: "Driving Forward",
      description:
        "Looking to the future, our company has set its sights on continued growth and expansion. We are dedicated to staying at the forefront of the industry, offering the latest and greatest. Whether it's through expanding our facility, offering new services, or partnering with leading brands, we are committed to delivering the best experience for our customers.",
      image: require("../../assets/images/aboutimage3.jpg"),
    },
  ];
